// Building Security
export function createBuildingSecurity(buildingId) {
  return {
    path: `buildings/${buildingId}/security`,
    method: 'POST',
    body: JSON.stringify({ building_id: buildingId }),
  };
}

export function getBuildingSecurity(buildingId) {
  return {
    path: `buildings/${buildingId}/security`,
  };
}

export function updateBuildingSecurity(buildingId, body) {
  return {
    path: `buildings/${buildingId}/security`,
    method: 'PUT',
    body: JSON.stringify(body),
  };
}

export function deleteBuildingSecurity(buildingId) {
  return {
    path: `buildings/${buildingId}/security`,
    method: 'DELETE',
  };
}

// Fire
export function searchFire(query) {
  return { path: `security/fire_monitors${query}` };
}

export function getFire(id) {
  return { path: `security/fire_monitors/${id}` };
}

export function createFire(name) {
  return {
    path: 'security/fire_monitors',
    method: 'POST',
    body: JSON.stringify({
      name,
    }),
  };
}

export function updateFire(id, name) {
  return {
    path: `security/fire_monitors/${id}`,
    method: 'PUT',
    body: JSON.stringify({
      name,
    }),
  };
}

export function deleteFire(id) {
  return {
    path: `security/fire_monitors/${id}`,
    method: 'DELETE',
  };
}

// Access Control
export function searchAccessControl(query) {
  return { path: `security/access_controls${query}` };
}

export function getAccessControl(id) {
  return { path: `security/access_controls/${id}` };
}

export function createAccessControl(name) {
  return {
    path: 'security/access_controls',
    method: 'POST',
    body: JSON.stringify({
      name,
    }),
  };
}

export function updateAccessControl(id, name) {
  return {
    path: `security/access_controls/${id}`,
    method: 'PUT',
    body: JSON.stringify({
      name,
    }),
  };
}

export function deleteAccessControl(id) {
  return {
    path: `security/access_controls/${id}`,
    method: 'DELETE',
  };
}

// Surveillance
export function searchSurveillance(query) {
  return { path: `security/surveillance${query}` };
}

export function getSurveillance(id) {
  return { path: `security/surveillance/${id}` };
}

export function createSurveillance(name) {
  return {
    path: 'security/surveillance',
    method: 'POST',
    body: JSON.stringify({
      name,
    }),
  };
}

export function updateSurveillance(id, name) {
  return {
    path: `security/surveillance/${id}`,
    method: 'PUT',
    body: JSON.stringify({
      name,
    }),
  };
}

export function deleteSurveillance(id) {
  return {
    path: `security/surveillance/${id}`,
    method: 'DELETE',
  };
}

// Intrusion
export function searchIntrusion(query) {
  return { path: `security/intrusion_monitors${query}` };
}

export function getIntrusion(id) {
  return { path: `security/intrusion_monitors/${id}` };
}

export function createIntrusion(name) {
  return {
    path: 'security/intrusion_monitors',
    method: 'POST',
    body: JSON.stringify({
      name,
    }),
  };
}

export function updateIntrusion(id, name) {
  return {
    path: `security/intrusion_monitors/${id}`,
    method: 'PUT',
    body: JSON.stringify({
      name,
    }),
  };
}

export function deleteIntrusion(id) {
  return {
    path: `security/intrusion_monitors/${id}`,
    method: 'DELETE',
  };
}
